<template>
  <div class="main_block">
    <el-form :model="dynamicValidateForm" :rules="rules" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
      <el-row>
        <el-col :span="24">
          <div class="grid-content top_nav"></div>
        </el-col>
      </el-row>
      <!-- 主体内容信息块 -->
      <div class="container_block">
        <!-- 头部进度状态 -->
        <div class="container_block_top" v-if="septId<5">
          <div :class='septId==1?"top_title_s":"top_title"'><a>01</a> 项目信息</div>
          <div :class='septId==2?"top_title_s":"top_title"'><a>02</a> 计划安排</div>
          <div :class='septId==3?"top_title_s":"top_title"'><a>03</a> 发布方式</div>
          <div :class='septId==4?"top_title_s":"top_title"'><a>04</a> 项目金额</div>
          <!-- <div :class='septId==5?"top_title_s":"top_title"'><a>05</a> 发布完成</div> -->
        </div>
        <div style="clear: both;"></div>
        <!-- 项目类型 -->
        <div class="pro_info" v-if="septId==1">




          <!-- 类型 -->
          <div class="pro_block" style="padding-bottom: 20px;padding-top:30px">
            <div>
              <el-form-item label="发布企业" prop="companyName">
                <el-input v-model="companyName" disabled placeholder="请选择代发企业">
                  <el-button slot="append" @click="companyGroup">选择</el-button>
                </el-input>
              </el-form-item>
              <!--企业查询-->
              <companylist ref="childcompany" @refresh="refresh"></companylist>
            </div>

            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>项目类型</div>
              </el-aside>
              <el-main class="pro_main" style="display: flex;">
                <div class="pro_type_item" v-for="(item,index) in grids_items" :key="index">
                  <a @click="selectType(item.name)">
                    <img :src="projectInfo.type == item.name ?item.activeicon:item.icon">
                  </a>
                </div>
              </el-main>
            </el-container>
            <div>
              <el-container class="pro_container" style="margin-top: 20px;">
                <el-aside class="pro_title">
                  <div>项目名称</div>
                </el-aside>
                <el-main class="pro_main pro_main_input">
                  <el-input class="pro_el-input" maxlength="20" v-model="projectInfo.name" placeholder="请输入项目名称"></el-input>
                </el-main>
              </el-container>
            </div>
          </div>
          <!-- 项目地址 -->
          <div class="pro_block">
            <el-container class="pro_container" v-for="(item, index) in projectInfo.adds" :key="index">
              <el-aside class="pro_title">
                <div>项目地址{{index>0?index:''}}</div>
              </el-aside>
              <el-main class="pro_main">
                <el-input class="pro_el-input mb_0" v-model="item.address" placeholder="请输入工程地址" prefix-icon="el-icon-location"></el-input>
                <div class="pro_el-input_item mt_20">
                  <el-input class="pro_el-input_s" placeholder="例:3号楼1单元101室(选填)" prefix-icon="el-icon-s-home" v-model="item.houseNum"></el-input>
                  <el-input class="pro_el-input_s" v-model="item.contacts" maxlength="10" prefix-icon="el-icon-user-solid" placeholder="现场联系人"></el-input>
                  <el-input class="pro_el-input_s" v-model="item.contactPhone"

                  prefix-icon="el-icon-phone" type="number"  onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                    placeholder="联系人电话" maxlength="11"></el-input>
                </div>
                <a class="pro_delete_img" @click="deleteaddress(index)" v-if="index>0"><img src="../../../../public/img/addProject/delete.png"></a>
              </el-main>
            </el-container>
            <el-button class="pro_button" icon="el-icon-plus" @click="address">添加更多地址</el-button>
          </div>
          <!-- 工作内容 -->
          <div class="pro_block" style="padding-bottom: 16px;">
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>工作内容</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button :class=" contentSource==2&&projectInfo.contents.length>0?'pro_button_content addbg':'pro_button_content' "
                    @click="addContent" icon="el-icon-plus">{{contentSource==2&&projectInfo.contents.length>0?'继续添加工作内容':'添加工作内容'}}</el-button>
                  <el-button :class='contentSource==1&&projectInfo.contents.length>0?"pro_button_import addbg":"pro_button_import"'
                    @click="importBtn" icon="el-icon-upload2">{{contentSource==1&&projectInfo.contents.length>0?'重新导入工作内容':'导入工作内容'}}</el-button>
                  <p class="pro_content_tips">添加工作内容、导入只可选择一个，可在导入中下载模板查看导入的格式内容</p>
                </el-row>
                <el-row v-if="contentSource!=1">
                  <div class="pro_content_li text_start" v-for="(item,index) in projectInfo.contents" :key="index">
                    <div class="li_index" @click="editContent(item)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editContent(item)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.tips}}</p>
                      <a class="pro_p_tips" style="padding-left: 15px;"><img src="../../../../public/img/addProject/pic.png">照片{{item.imgCount}}张</a>
                      <a class="pro_p_tips" style="margin-left: 28px;"><img src="../../../../public/img/addProject/video.png">视频{{item.videoCount}}个</a>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletetask(index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
                <!-- 表格内容 -->
                   <div v-else class="uploadFile">
                  <el-table :data="projectInfo.contents.slice((contentListData.currentPage-1)*contentListData.pageSize,contentListData.currentPage*contentListData.pageSize)"
                    border style="width: 88.6%;">
                    <el-table-column prop="id" label="序号" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="品名" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="brand" label="品牌" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="contentType" label="型号" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="contentNum" label="数量" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="contentUnit" label="单位" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="position" label="位置" height="40" align="center">
                    </el-table-column>
                    <el-table-column prop="describe" label="描述/颜色" height="40" align="center">
                    </el-table-column>
                  </el-table>
                  <el-pagination class="pro_pagination" background layout="prev, pager, next" @current-change="handleCurrentChange"
                    :total="projectInfo.contents.length">
                  </el-pagination>
                </div>
              </el-main>
            </el-container>
          </div>
          <!-- 备注 -->
          <div class="pro_block border_bottom" style="padding-bottom: 24px;">
            <div>
              <el-container class="pro_container">
                <el-aside class="pro_title">
                  <a>备注</a><a>(选填)</a>
                </el-aside>
                <el-main class="pro_main">
                  <textarea class="pro_bz" v-model="projectInfo.describe"></textarea>
                  <div class="limit_width">
                    <el-upload ref="uploadWorkFj" :on-success="handleWorkFjSuccess" :file-list="projectInfo.files"
                     :action="'/files/fileUpload'|getBaseApiUrl" :on-remove="handleFjRemove" :before-remove="beforeFjRemove"
                      accept="image/*, .pdf, .doc, .docx, .xls, .xlsx">
                      <el-button class="pro_button_fj" icon="el-icon-upload2">上传附件<a style="color: #909399;">(选填)</a></el-button>
                      <a class="pro_fj_tips">附件支持jpg，png，xlsx，docx，pdf，且20MB以内</a>
                    </el-upload>
                  </div>

                </el-main>
              </el-container>
            </div>
          </div>
        </div>
        <!-- 排班计划 -->
        <div class="pro_jh" v-if="septId==2">
          <div class="pro_block" style="padding-bottom: 30px;">
            <el-row class="pro_container" :gutter="20">
              <el-col :span="10">
                <span class="pro_jh_title" style="margin-right: 15px;">预计工期</span>
                <el-input class="pro_workTime" type="number" v-model='workScheduleRule.duration' placeholder="请输入预计工期" @change="durationInput"
                          prefix-icon="el-icon-alarm-clock"></el-input>
              </el-col>
              <el-col :span="9">
                <span class="pro_jh_title" style="margin-right: 28px;">开始时间</span>
                <el-date-picker class="pro_workTime" v-model="workScheduleRule.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm"
                                placeholder="选择日期" :picker-options="pickerOptions0" @change="changeTableDate">
                </el-date-picker>
              </el-col>

            </el-row>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>现场勘查计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button class="pro_button_content"
                             @click="addProspection" icon="el-icon-plus">添加现场勘查计划</el-button>
                </el-row>
                <el-row>
                  <div class="pro_content_li text_start" style="margin-top:20px;" v-for="(item,index) in prospecting" :key="index">
                    <div class="li_index" @click="editProspection(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editProspection(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletePlan(1,index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>到货计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button class="pro_button_content"
                             @click="addDaohuolPlan" icon="el-icon-plus">添加到货计划</el-button>
                </el-row>
                <el-row>
                  <div class="pro_content_li text_start" style="margin-top:20px;" v-for="(item,index) in daohuoPlanList" :key="index">
                    <div class="li_index" @click="editDaohuoPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editDaohuoPlan(item,index)">
                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.logisticsCompany}}({{item.logisticsNo}})</el-col>
                      <el-col :span="24" v-if="item.arrivalMode=='自提'"  class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                        {{item.arrivalDataInfo.addr}}&nbsp;&nbsp;{{item.arrivalDataInfo.jianshu}}件&nbsp;&nbsp;{{item.arrivalDataInfo.fangshu}}数
                      </el-col>

                      <el-col :span="24" v-if="item.arrivalMode=='货到现场'" v-for="(carIformation,index) in item.carIformationList" :key="index" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                        {{carIformation.carModel}}&nbsp;&nbsp;{{carIformation.number}}件&nbsp;&nbsp;{{carIformation.SquareNumber}}方
                      </el-col>

                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">联系人：{{item.logisticsUser}}&nbsp;&nbsp;联系电话：{{item.phone}}</el-col>
                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.isTransport}}&nbsp;&nbsp;{{item.arrivalMode}}</el-col>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletePlan(2,index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>安装计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button class="pro_button_content"
                             @click="addInstallPlan" icon="el-icon-plus">添加安装计划</el-button>
                </el-row>
                <el-row>
                  <div class="pro_content_li text_start" style="margin-top:20px;" v-for="(item,index) in installationPlanList" :key="index">
                    <div class="li_index" @click="editInstallPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editInstallPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">安装工：{{item.anzhuangNum}}人 搬运工：{{item.banyunNum}}人 &nbsp;&nbsp;{{item.workOvertime==0?'无需加班':'需要加班'}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletePlan(3,index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>验收计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button class="pro_button_content"
                             @click="addArrivalPlan" icon="el-icon-plus">添加验收计划</el-button>
                </el-row>
                <el-row>
                  <div class="pro_content_li text_start" style="margin-top:20px;" v-for="(item,index) in arrivalPlanList" :key="index">
                    <div class="li_index" @click="editArrivalPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editArrivalPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletePlan(4,index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>回访计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <el-button class="pro_button_content"
                             @click="addReturnVisitPlan" icon="el-icon-plus">添加回访计划</el-button>
                </el-row>
                <el-row>
                  <div class="pro_content_li text_start" style="margin-top:20px;" v-for="(item,index) in returnVisitPlanList" :key="index">
                    <div class="li_index" @click="editReturnVisitPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editReturnVisitPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                    <div class="li_delete" style="margin-right: 33px;" @click="deletePlan(5,index)"><img src="../../../../public/img/addProject/delete.png"></div>
                  </div>
                </el-row>
              </el-main>
            </el-container>

          </div>

        </div>
        <!-- 发布方式 -->
        <div class="pro_block_s" v-if="septId==3">
            <el-header class="pro_el_header">
              <div>发布方式</div>
            </el-header>

            <div style="padding: 20px 20px 0px 20px;">
              <el-row class="space_between">
                <!-- 需求大厅发布 -->
                <el-col :class='publishingMode.type==1? "pro_col_item_checked span_width":"pro_col_item span_width"'
                  :span="6">
                  <div @click="selectPublishingMode" data-type='1'>
                    <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                      <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/qwfb.png"></el-col>
                      <el-col :span="12" class="pro_sendWays_btncheck"><img :src='publishingMode.type==1?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
                    </el-row>
                    <div class="pro_sendWays_row">
                      <p class="pro_sendWays_title">需求大厅发布</p>
                      <p class="pro_sendWays_tips">全网发布，所有工种的师傅都能看到</p>
                    </div>
                  </div>
                </el-col>
                <!-- 群组发布 -->
                <el-col :class='publishingMode.type==2? "pro_col_item_checked span_width":"pro_col_item span_width"'
                  :span="6">
                  <div @click="selectPublishingMode" data-type='2'>
                    <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                      <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/qzfb.png"></el-col>
                      <el-col :span="12" class="pro_sendWays_btncheck"><img :src='publishingMode.type==2?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
                    </el-row>
                    <div class="pro_sendWays_row">
                      <p class="pro_sendWays_title">群组发布</p>
                      <p class="pro_sendWays_tips">发布给本企业的师傅群组</p>
                    </div>
                  </div>
                </el-col>
                <!-- 师傅发布 -->
                <el-col :class='publishingMode.type==3? "pro_col_item_checked span_width":"pro_col_item span_width"'
                  :span="6">
                  <div @click="selectPublishingMode" data-type='3'>
                    <el-row class="pro_sendWays_btnImg_checked" justify="space-around">
                      <el-col :span="12" class="pro_sendWays_img"><img src="../../../../public/img/addProject/sffb.png"></el-col>
                      <el-col :span="12" class="pro_sendWays_btncheck"><img :src='publishingMode.type==3?workTypeImg.isSelected:workTypeImg.unSelected'></el-col>
                    </el-row>
                    <div class="pro_sendWays_row">
                      <p class="pro_sendWays_title">师傅发布</p>
                      <p class="pro_sendWays_tips">发布给本企业的指定师傅</p>
                    </div>
                  </div>
                </el-col>
              </el-row>

              <el-row class="space_between">
                      <el-col :span="6"><div class="arrow-top" v-if="false"></div></el-col>
                      <el-col :span="6"><div class="arrow-top" v-if="publishingMode.type==2"></div></el-col>
                      <el-col :span="6"><div class="arrow-top" v-if="publishingMode.type==3"></div></el-col>
              </el-row>
            </div>
            <el-footer class="pro_footer" v-if="publishingMode.type>1">
              <div class="pro_sendWays_group">
                <div class="qr_main_1">
                  <div class="man_list" style="padding-top: 15px;padding-left: 15px;">
                    <div class="ava_img" v-for="(item,index) in publishingMode.type==3?publishingMode.works:publishingMode.groups" :key="index">
                      <!-- <div v-if='publishingMode.type==3'><img :src="item.headimgurl?item.headimgurl:workTypeImg.avatar"/></div> -->
                      <div v-if='publishingMode.type==3'><img :src="item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:'/img/default-avatar.png')"/></div>
                      <div v-else><img :src="item.headimgurl?item.headimgurl:workTypeImg.group"/></div>
                      <div class="ava_name">{{publishingMode.type==3?item.name:item.groupName}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-footer>
        </div>

        <!-- 项目相关人 -->
        <div class="pro_block_s border_bottom" v-if="septId==3">
          <div class="pro_xgr" @click="showXgr"  style="width: 630px;margin: auto;">
            <span class="pro_xgr_img"><img src="../../../../public/img/addProject/xgr.png"></span>
            <div class="pro_xgr_tips">
              <p class="pro_xgr_title">项目相关人</p>
              <p class="pro_xgr_tip">项目相关人为企业员工，及时收到项目信息</p>
            </div>
            <p class="pro_deleteAlt">
              <img :src='publishingMode.stakeholders.length>0?workTypeImg.isSelected:workTypeImg.unSelected '>
            </p>
          </div>

          <div class="pro_xfrAvatar" v-if="publishingMode.stakeholders.length>0" style="margin-top: 20px;padding-left: 15px;">
            <div class="qr_main_1" style="width: 630px;margin: auto;height:auto;">
              <myAvatar :manArr="publishingMode.stakeholders"></myAvatar>
            </div>
          </div>
        </div>
        <!-- 协作联系人 -->
        <div class="pro_block border_bottom" v-if="septId==3">
          <p class="pro_p_tips" style="margin-bottom: 20px;">项目执行过程中的协作人员，如：强电、弱电、装修、甲方人员等。请写明工作职责、姓名以及手机号。</p>
          <el-container class="pro_container" v-for="(item, index) in workScheduleRule.relevantContacts" :key="index">
            <el-aside class="pro_title width_135">
              协作联系人{{index>0?index:''}}<a style="color: #909399;font-size: 14px;">(选填)</a>
            </el-aside>
            <el-main class="pro_main">
              <div style="overflow: hidden;">
                <el-input class="pro_altinput" prefix-icon="el-icon-menu" maxlength="7" placeholder="工作职责" type="text" v-model="item.type"></el-input>
                <el-input class="pro_altinput" prefix-icon="el-icon-user-solid" maxlength="10" placeholder="请输入姓名" type="text"
                          v-model="item.name"></el-input>
                <el-input class="pro_altinput" prefix-icon="el-icon-phone" maxlength="11" placeholder="请输入手机号" type="number" v-model="item.phone"></el-input>
                <div class="pro_deleteAlt_img" @click="deleteAltConnecter(index)" v-if="index>0"><img src="../../../../public/img/addProject/delete.png"></div>
              </div>
            </el-main>
          </el-container>
          <div class="bottom_btn">
            <el-button class="borderbtn addAlt" icon="el-icon-plus" @click="addAltconnecter">添加协作联系人</el-button>
          </div>
        </div>
        <!-- 项目金额 -->
        <div v-if="septId==4">
          <div class="pro_block">
<!--            <el-container class="pro_container" style="padding-right:60px">-->
<!--              <el-aside class="pro_title" style="font-size: 16px;">-->
<!--                <div>项目金额</div>-->
<!--              </el-aside>-->
<!--              <el-main class="pro_main pro_main_input p-input">-->
<!--                <el-input type="number" v-model="allPrice" placeholder="请输入项目金额"></el-input>-->
<!--                <div style="padding-left: 15px;color: #bfc2cc;font-size: 14px;">元</div>-->
<!--              </el-main>-->
<!--            </el-container>-->
            <el-form
              :rules="rules" :model="proForm"
              label-width="120px">
              <el-form-item label="项目金额" prop="allPrice">
                <el-input
                  ref="inputValue"
                  type="number"
                  v-model="proForm.allPrice"
                  placeholder="请输入项目金额"
                  clearable
                  @blur="_formatAmount"
                />
              </el-form-item>
            </el-form>
          </div>
          <div class="pro_block border_bottom">
            <div v-if="priceOfCity.isShowPrice">
               <div class="p-info">
                 <div>
                   <div class="p-title">平台预估(以{{priceOfCity.thisCity}}市场价为准)</div>
                   <div class="p-tips">平台估价是根据工种的市场价格定位，价格仅供参考</div>
                 </div>
                 <div class="p-price">
                   <div class="p-yuan">¥</div>
                   <div class="fz-48">{{priceOfCity.allPrice}}</div>
                 </div>
               </div>
               <div class="p-detail">
                 <div v-for="(item,index) in cityPrice" :key="index">
                   <span v-if="item.needNum>0" class="mt-10">
                     <div>
                       <span style="margin-right: 62px;">{{item.workerTypeName}}</span>
                       <span style="padding: 0 34px 0 24px;" v-if="item.isShow">{{item.predictPrice}}元/人天 * {{item.needNum}} (人天)</span>
                       <span style="padding: 0 34px 0 24px;" v-else>当前城市没有设置该工种价格</span>
                     </div>
                     <div v-if="item.isShow">
                       <span style="padding-right: 8px;">¥</span>
                       <span>{{item.predictPrice*item.needNum}}元</span>
                     </div>
                   </span>
                 </div>
               </div>
             </div>
             <div v-else style="padding-top: 38px;padding-left: 32px;">
               <div class="p-tips">当前城市没有设置该工种价格</div>
             </div>
             <div style="display: flex;justify-content: flex-end;width: 100%;" v-if="priceOfCity.isShowPrice">
                <button class="p-btn" @click="useThisPrice">使用估价</button>
             </div>
          </div>
        </div>

        <!-- 确认信息 -->
        <div class="pro_confirm" v-if="septId==5">
          <!-- 项目金额 -->
          <div class="pro_qr">
            <div class="pro_qr_title pro_qr_text">
              项目金额
            </div>
            <div class="pro_qr_img"  @click="editInfo" data-type="4">
              <span class="qr_img"> <img src="../../../../public/img/addProject/rewrite.png"></span>
              <span class="pro_qr_btn pro_qr_text">修改</span>
            </div>
          </div>
          <div class="qr_main qr_main_1">
            <div class="qr_main_left">
              <span class="main_title">项目金额：</span>
              <span class="p-price" style="justify-content: flex-start;">
                <span class="p-yuan" style="margin-top: 6px;">¥</span>
                <span class="fz-48">{{proForm.allPrice}}</span>
              </span>
            </div>
          </div>
          <!-- 头部 -->
          <div class="pro_qr">
            <div class="pro_qr_title pro_qr_text">
              项目信息
            </div>
            <div class="pro_qr_img"  @click="editInfo" data-type="1">
              <span class="qr_img"> <img src="../../../../public/img/addProject/rewrite.png"></span>
              <span class="pro_qr_btn pro_qr_text">修改</span>
            </div>
          </div>
          <!-- 主体信息块 -->
          <!-- 项目名称 类型 -->
          <div class="qr_main qr_main_1">
            <div class="qr_main_left">
              <span class="main_title">项目名称：</span>
              <span class="main_info">{{projectInfo.name}}</span>
            </div>
            <div class="qr_main_right">
              <span class="main_title">项目类型：</span>
              <span class="main_info">{{projectInfo.type}}</span>
            </div>
          </div>
          <!-- 项目地址 -->
          <div class="qr_main qr_main_2" style="display: block;">
            <div class="qr_pos" style="padding-top: 12px;" v-for="(item,index) in projectInfo.adds" :key="index">
              <div class="qr_info1 addPadding">
                <div class="qr_main_left smallHeight">
                  <span class="main_title">工程地址{{index+1}}：</span>
                  <span class="main_info_pos">{{item.address}}{{item.houseNum}}</span>
                </div>

                <div style="width:200px;">
                  <span class="main_info">{{item.contacts}}</span>
                  <span class="main_info main_info_phone">{{item.contactPhone}}</span>
                </div>

              </div>
            </div>
          </div>
          <!-- 工作内容 -->
          <div class="qr_main qr_main_1">

            <div class="qr_main_right">
              <div class="main_title ">
                <div class="fullHeight">工作内容:</div>
              </div>
              <div class="qr_main_list" v-if="projectInfo.contents">
                <div class="pro_content_li text_start" v-for="(item,index) in projectInfo.contents" :key="index">
                  <div class="li_index" @click="editContent(item)">{{index+1}}</div>
                  <div class="li_info">
                    <p class="pro_p_tips" style="line-height: 20px;">{{item.tips}}</p>
                    <a class="pro_p_tips"><img src="../../../../public/img/addProject/pic.png">照片{{item.imgCount}}张</a>
                    <a class="pro_p_tips" style="margin-left: 28px;"><img src="../../../../public/img/addProject/video.png">视频{{item.videoCount}}个</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 备注 附件 -->
          <div class="qr_main qr_main_2">
            <div class="qr_pos" style="padding-top: 12px;">
              <div class="qr_info1 addPadding" style="height: auto; align-items:flex-start;">
                <div class="main_title toright" style="margin-left: 33px;">备注：</div>
                  <div class="main_info" style="padding-right: 50px;">
                    {{projectInfo.describe}}
                  </div>
              </div>

              <div class="qr_info1 addPadding" style="height: auto; align-items:center;" v-if="projectInfo.files.length>0">
                <div class="main_title toright" style="margin-left: 33px;">附件：</div>
                <div>
                  <div v-for="(item,index) in projectInfo.files" :key="index" class="pr-fjblock">
                    <a class="pro_fj_img">
                      <img src="../../../../public/img/addProject/png.png" v-if="item.type=='png'">
                      <img src="../../../../public/img/addProject/PDF.png" v-if="item.type=='pdf'">
                      <img src="../../../../public/img/addProject/jpg.png" v-if="item.type=='jpg'">
                      <img src="../../../../public/img/addProject/excel.png" v-if="item.type=='excel'">
                      <img src="../../../../public/img/addProject/doc.png" v-if="item.type=='word'">
                    </a>
                    <span class="main_info" style="line-height: 30px;">{{item.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 排班计划块 -->
          <!-- 头部 -->
          <div class="pro_qr">
            <div class="pro_qr_title pro_qr_text">
              计划安排
            </div>
            <div class="pro_qr_img">
              <span class="qr_img" @click="editInfo" data-type="2"> <img src="../../../../public/img/addProject/rewrite.png"></span>
              <span class="pro_qr_btn pro_qr_text">修改</span>
            </div>
          </div>
          <div class="qr_main_1 table_margin">


            <el-row class="pro_container" :gutter="20">
              <el-col :span="10">
                <span class="pro_jh_title" style="margin-right: 15px;">预计工期：{{workScheduleRule.duration}}天</span>

              </el-col>
              <el-col :span="9">
                <span class="pro_jh_title" style="margin-right: 28px;">开始时间：{{workScheduleRule.startDate}}</span>
              </el-col>

            </el-row>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>现场勘查计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <div class="pro_content_li text_start"  v-for="(item,index) in prospecting" :key="index">
                    <div class="li_index" @click="editProspection(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editProspection(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                  </div>
                </el-row>
                <div class="pro_content_li text_start"  v-if="prospecting.length==0">
                  无
                </div>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>到货计划</div>
              </el-aside>
              <el-main class="pro_main">

                <el-row>
                  <div class="pro_content_li text_start"  v-for="(item,index) in daohuoPlanList" :key="index">
                    <div class="li_index" @click="editDaohuoPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editDaohuoPlan(item,index)">
                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.logisticsCompany}}({{item.logisticsNo}})</el-col>
                      <el-col :span="24" v-if="item.arrivalMode=='自提'"  class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                        {{item.arrivalDataInfo.addr}}&nbsp;&nbsp;{{item.arrivalDataInfo.jianshu}}件&nbsp;&nbsp;{{item.arrivalDataInfo.fangshu}}数
                      </el-col>

                      <el-col :span="24" v-if="item.arrivalMode=='货到现场'" v-for="(carIformation,index) in item.carIformationList" :key="index" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">
                        {{carIformation.carModel}}&nbsp;&nbsp;{{carIformation.number}}件&nbsp;&nbsp;{{carIformation.SquareNumber}}方
                      </el-col>

                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">联系人：{{item.logisticsUser}}&nbsp;&nbsp;联系电话：{{item.phone}}</el-col>
                      <el-col :span="24" class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.isTransport}}&nbsp;&nbsp;{{item.arrivalMode}}</el-col>
                    </div>

                  </div>
                  <div class="pro_content_li text_start" v-if="daohuoPlanList.length==0">
                    无
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>安装计划</div>
              </el-aside>
              <el-main class="pro_main">

                <el-row>
                  <div class="pro_content_li text_start"  v-for="(item,index) in installationPlanList" :key="index">
                    <div class="li_index" @click="editInstallPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editInstallPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">安装工：{{item.anzhuangNum}}人 搬运工：{{item.banyunNum}}人 &nbsp;&nbsp;{{item.workOvertime==0?'无需加班':'需要加班'}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>

                  </div>
                  <div class="pro_content_li text_start" v-if="installationPlanList.length==0">
                    无
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>验收计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <div class="pro_content_li text_start"  v-for="(item,index) in arrivalPlanList" :key="index">
                    <div class="li_index" @click="editArrivalPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editArrivalPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>

                  </div>
                  <div class="pro_content_li text_start"  v-if="arrivalPlanList.length==0">
                    无
                  </div>
                </el-row>
              </el-main>
            </el-container>
            <el-container class="pro_container">
              <el-aside class="pro_title">
                <div>回访计划</div>
              </el-aside>
              <el-main class="pro_main">
                <el-row>
                  <div class="pro_content_li text_start"  v-for="(item,index) in returnVisitPlanList" :key="index">
                    <div class="li_index" @click="editReturnVisitPlan(item,index)">{{index+1}}</div>
                    <div class="li_info" style="cursor: pointer;" @click="editReturnVisitPlan(item,index)">
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.planDate}}</p>
                      <p class="pro_p_tips" style="padding-left: 15px;max-width: 95%;word-break: break-all;">{{item.content}}</p>
                    </div>
                  </div>
                  <div class="pro_content_li text_start" v-if="returnVisitPlanList.length==0">
                    无
                  </div>
                </el-row>
              </el-main>
            </el-container>
          </div>
          <!-- 联系人 -->
          <div class="qr_main qr_main_1">
            <!-- 相关联系人 -->
            <div class="lxr_d" v-if="workScheduleRule.relevantContacts[0].name!=''" v-for="(item,index) in workScheduleRule.relevantContacts"
              :key="index">
              <div class="lxr_type">{{item.type}}: </div>
              <a class="lxr_info">
                <a>{{item.name}}</a><a>{{item.phone}}</a>
              </a>
            </div>
            <div class="clearfix"></div>
          </div>
          <!-- 发布方式 -->
          <div class="pro_qr">
            <div class="pro_qr_title pro_qr_text">
              发布方式
            </div>
            <div class="pro_qr_img">
              <span class="qr_img" @click="editInfo" data-type="3"> <img src="../../../../public/img/addProject/rewrite.png"></span>
              <span class="pro_qr_btn pro_qr_text">修改</span>
            </div>
          </div>
          <div class="qr_main qr_main_1">
            <div class="fb_main">
              <div class="fb_title">
                <span v-if="publishingMode.type==1">需求大厅发布</span>
                <span v-if="publishingMode.type==2">群组发布</span>
                <span v-if="publishingMode.type==3">师傅发布</span>
              </div>
              <div v-if="publishingMode.type>1">
                <div class="man_list">
                  <div class="ava_img" v-for="(item,index) in (publishingMode.type==3?publishingMode.works:publishingMode.groups)" :key="index">
                    <div v-if="publishingMode.type==3"><img :src='item.avatar?getimgpath(item.avatar):(item.headimgurl?item.headimgurl:"img/default-avatar.png")'/></div>
                    <div v-else><img src="/img/addProject/default-group.png"/></div>
                    <div class="ava_name">{{publishingMode.type==3?item.name:item.groupName}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 相关人 -->
          <div class="qr_main qr_main_1">
            <div class="fb_main">
              <div class="fb_title">项目相关人</div>
              <div>
                <div class="man_list">
                  <div class="ava_img" v-for="(item,index) in publishingMode.stakeholders" :key="index">
                    <div><img :src='item.avatar?item.avatar:(item.headimgurl?item.headimgurl:"img/default-avatar.png")'/></div>
                    <div class="ava_name">{{item.name?item.name:item.userName}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 发布完成 -->
        <div class="pro_done" v-if="septId==6">
          <div class="done">
            <img src="../../../../public/index/img/success_fill.png">
            <p>发布成功</p>
            <el-button class="commonbtn1 blockbtn" @click="oneMore">发布下一个需求</el-button>
            <el-button class="commonbtn1 borderbtn" @click="toManage">进入项目管理查看状态</el-button>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="foot_btn">
          <el-button class="commonbtn borderbtn" v-if="septId>1" @click="savebtn">保存</el-button>
          <!-- <el-button v-if="septId<4" class="commonbtn blockbtn" @click="nextSept">{{isReEdit?'完成修改':'下一步'}}</el-button> -->
          <el-button v-if="septId<5" class="commonbtn blockbtn" @click="nextSept">下一步</el-button>
          <el-button v-if="septId==5" class="commonbtn blockbtn" @click="ReleaseInfo">发布</el-button>
          <el-button class="commonbtn graybtn" @click="Releasecancel">取消</el-button>
        </div>
      </div>
      <!--导入工作内容-->
      <el-dialog class="pro_dialog" title="导入" width="500px" height="300px" :visible.sync="uploadfileDialog">
        <div class="pro_di_tips">
          <a class="main_info">请按照模板格式上传excel文件</a>
          <a class="pro_downmod" href="https://www.91worker.cn/wxstatic/images/yuanyang1.xlsx" download="模板文件">下载模板</a>
        </div>
        <el-upload class="upload-demo" ref="uploadContent" :action="urls" :data="uploaddata" accept=".xls, .xlsx"
          :on-success="handleAvatarSuccess" :auto-upload="false">
          <el-button slot="trigger" size="small" icon="el-icon-upload2">选取文件</el-button>
        </el-upload>
        <div class="pro_foot_di">
          <el-button class="graybtn width_80 fz_12" @click="cancelUpload">取消</el-button>
          <el-button class="blockbtn width_80 fz_12" @click="submitUpload">确定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑工作内容 -->
      <editContent ref="editContent" @setContent="setContent"></editContent>
      <!-- 编辑勘查、验收、回访计划内容 -->
      <editBasePlan ref="editBasePlan" :typeName="planTypeName" @setContent="setBasePlanContent"></editBasePlan>
      <editDaohuoPlan ref="editDaohuoPlan"  @setContent="setBasePlanContent"></editDaohuoPlan>
      <editInstallPlan ref="editInstallPlan"  @setContent="setBasePlanContent"></editInstallPlan>
    </el-form>
    <!--师傅群组-->
    <el-dialog title="师傅群组" :visible.sync="workerGroupVisible">

      <avue-crud :data="workerGroupData" :option="tableoptionqz" ref="groupCrud" @search-change="searchChangeqz"
                 @row-click="workerGroupchange" @select="workerGroupchange" @selection-change='workerGroupchange'>

      </avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workerGroupVisible = false">取消</el-button>
        <el-button @click="workerGroupTrue">确定</el-button>
      </div>
    </el-dialog>
    <!--师傅-->
    <el-dialog title="师傅列表" :visible.sync="workerVisible">
      <avue-crud-table :data="workerData" :option="tableoptionworkers" @search-change="searchChangegr" ref="workerCrud"
                       @row-click="workSelectionChange" @select="workSelectionChange" @selection-change='workSelectionChange'>
      </avue-crud-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workerVisible = false">取消</el-button>
        <el-button @click="workerTrue">确定</el-button>
      </div>
    </el-dialog>
    <!--项目相关人-->
    <el-dialog title="项目相关人" :visible.sync="projectManVisible">

      <avue-crud :data="comworkerData" :option="tableoption" @refresh-change="searchChange" ref="userCrud"
                 @row-click="selectionChange" @select="selectionChange" @selection-change='selectionChange'>
        <template slot="search">
          <el-form-item label="关键字">
            <el-input v-model="search.conditions"></el-input>
          </el-form-item>
        </template>
      </avue-crud>
      <div slot="footer" class="dialog-footer">
        <el-button class="borderbtn mr_6" @click="projectManVisible=false">取消</el-button>
        <el-button class="borderbtn mr_6" @click="chooseTrue">确定</el-button>
      </div>
    </el-dialog>
    <!--验证提示框-->
    <el-dialog title="认证提示" :visible.sync="VerificationVisible">
      <div>{{message}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="VerificationVisible = false">继续发布</el-button>
      </div>
    </el-dialog>
    <!--发布渠道-->
    <el-dialog title="发布渠道" :visible.sync="workerVisiblequdao">
      <div style="height: auto;margin-bottom: 15px;" v-if="classA == true">需求大厅</div>
      <div style="height: auto;margin-bottom: 15px;" v-if="workerGrouptags.length>0">
        群组
        <el-tag v-for="tag in workerGrouptags" :key="tag.id" :disable-transitions="true" :type="tag.type" style="margin-left:15px;">{{tag.groupName}}</el-tag>
      </div>
      <div style="height:200px;" v-if="ownWorker.length>0">
        <span style="float:left;">师傅</span>
        <div v-for="tag in ownWorker" :key="tag.name" :disable-transitions="true" :type="tag.type" style="width: 80px;float: left;">
          <img :src="tag.avatar?getimgpath(tag.avatar):(tag.headimgurl?tag.headimgurl:'/img/default-avatar.png')" style="width:60px;border-radius:50%;">
          <el-tag>{{tag.name}}</el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="quertok">确定</el-button>
        <el-button @click="workerVisiblequdao = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getGroupList,
    getWorkerList,
    getPredictPriceForCcode,
    insertOrUpdate
  } from "@/api/admin/addProject";
  import {
    urls
  } from "@/config/env";
  import {
    getDictList
  } from "@/api/admin/dict";
  import {

    getProjectInfo,
    updateProjectChannel
  } from "@/api/admin/taskManagement";
  import {
    getWorkerInfo,
    getdicts
  } from "@/api/admin/business";
  import {
    mapGetters
  } from "vuex";
  import {
    fetchList
  } from "@/api/admin/groups";
  import {
    objKeySort
  } from "@/util/ajaxsign";
  import {
    getImgLink,
    apiLink
  } from "@/config/env";
  import {
    personnelget1,
    groupqz,
    tableoptionworkers
  } from "@/const/asset/user";
  import {
    dealElement,
    matchType,
    checkPhone,
    toFixed2
  } from "@/util/util";
  import editContent from "./editContent";
  import editBasePlan from "../planComponents/editBasePlan";
  import editDaohuoPlan from "../planComponents/editDaohuoPlan";
  import editInstallPlan from "../planComponents/editInstallPlan";
  import easyTable from "../../common/easytable.vue";
  import myAvatar from "../components/myAvatar.vue";
  import '@/styles/addProject.scss';
  import companylist from './companylist.vue'
  import {
    getDateStr,
    dateSplit
  } from '@/util/date';
  export default {
    data() {
      return {
        nowDate: '',
        septId: '1', //tabar序列
        isReEdit: false, //是否是返回修改状态
        //日期可选择范围为 当前使时间之后
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() <= new Date().getTime() - 86400000;
          }
        },
        classA: false,
        workerVisiblequdao: false,
        projectId: "",
        companyName:"",
        editType:'',//发布的入口类型 update修改，release重新发布  republish再次发布
        companyState: 0,
        isAdmin: true,
        totalStatus: true,
        uploaddata: {
          Token: "",
          projectId: ""
        },
        searchgr: {},
        fadate: "",
        ownWorker:[],//已选择的师傅
        ownGroup:[],//已选择的群组
        ownStakeholders:[],//已选择的群组
        dic: {
          workTypes: [],
          skillTips: [],
          groups: []
        },
        handleSuccessstate: false,
        urls: urls.apiLink + "/uploadProjectContent/uploadProjectContent",
        locBaseImgUrl: '../../../../public/img/addProject/',
        grids_items: [{
          name: '安装',
          icon: require('../../../../public/img/addProject/az.png'),
          activeicon: require('../../../../public/img/addProject/activeaz.png'),
        }, {
          name: '安装搬运',
          icon: require('../../../../public/img/addProject/azby.png'),
          activeicon: require('../../../../public/img/addProject/activeazby.png'),
        }, {
          name: '搬运',
          icon: require('../../../../public/img/addProject/by.png'),
          activeicon: require('../../../../public/img/addProject/activeby.png'),
        }, {
          name: '售后客诉',
          icon: require('../../../../public/img/addProject/shks.png'),
          activeicon: require('../../../../public/img/addProject/activeshks.png'),
        }], //需求发布 按钮图标  无需修改
        //项目信息对象
        projectInfo: {
          type: undefined, //项目类型
          name: '', //项目名称
          adds: [], //项目地址
          contents: [], //工作内容
          describe: '', //备注
          files: [] //附件路径
        },
        //排班计划对象
        workScheduleRule: {
          duration: 1,
          isWorkOvertime: false, //是否需要加班
          startDate: '', //开始时间
          workTypeTable: [],
          workerTypes: [], //需求工种详情
          relevantContacts: [], //协作联系人
          workTypeDict: []
        },
        priceType:[],
        //发布方式对象
        publishingMode: {
          type: 0, //发布方式，1需求大厅，2群组，3师傅
          groups: [], //发布到群组，群组数据
          works: [], //发布到师傅,师傅数据
          stakeholders: [],//项目相关人
          stakeholdersTemp:[]//临时存储 用于提交数据
        },
        uploadFiles:[],//再次发布 项目附件
        dateTimeList: [],
        dateTimeIndex: [1, 9],
        timeOut: 4,
        cityPrice:[],//平台预估价
        proForm:{
          allPrice:'',//默认金额
        },
        priceOfCity:{},//参考城市（固定北京）
        workTypeImg: {
          az: require('../../../../public/img/addProject/az.png'),
          activeaz: require('../../../../public/img/addProject/activeaz.png'),
          azby: require('../../../../public/img/addProject/azby.png'),
          activeazby: require('../../../../public/img/addProject/activeazby.png'),
          by: require('../../../../public/img/addProject/by.png'),
          activeby: require('../../../../public/img/addProject/activeby.png'),
          shks: require('../../../../public/img/addProject/shks.png'),
          activeshks: require('../../../../public/img/addProject/activeshks.png'),
          png: require('../../../../public/img/addProject/png.png'),
          excel: require('../../../../public/img/addProject/excel.png'),
          jpg: require('../../../../public/img/addProject/jpg.png'),
          pdf: require('../../../../public/img/addProject/PDF.png'),
          isSelected: require('../../../../public/img/addProject/checked.png'),
          unSelected: require('../../../../public/img/addProject/unchecked.png'),
          avatar:require('../../../../public/img/addProject/default-avatar.png'),
          group:require('../../../../public/img/addProject/default-group.png')
        },
        planTypeName:"勘查",
        uploadAction: "",
        tableWidth1: { //设置不同页面的tr th 宽度
          th: '216.5',
          td: '140',
          isEdit: true
        },
        tableWidth2: { //设置不同页面的tr th 宽度
          th: '220',
          td: '179.4',
          isEdit: false
        },
        contentListData: {}, // 详细工作内容
        contentSource: null, //工作内容类型
        uploadfileDialog: false,
        addWorkContentDialog: false, //添加工作内容dialog
        addImgDialog: false, //图片上传dialog
        addVideoDialog: false, //视频上传dialog
        dialogImageUrl: '', //图片地址
        dialogVideoUrl: '', //视频地址
        orderNum: "",
        message: "该企业未认证，任务无法发布到需求大厅，只能自己邀请师傅来进行",
        VerificationVisible: false, // 验证提示框
        workerGroupData: [], // 师傅群组

        userInfo: "", // 用户信息
        companyId: "",
        radio: "",
        comworkerData: [],
        workerData: [], // 师傅数据
        tableLoading: false,
        projectManVisible: false, // 项目相关人弹框开关
        workerGroupVisible: false, // 师傅群组弹框
        workerVisible: false,
        workerGrouptags: [], // 师傅群组标签
        ownWokerTags:[], // 我的师傅标签
        tagsArr: "",
        workerGrouptagsArr: "", // 师傅群组选中记录
        createVisible: false, // 弹框开关
        tableData: [], // 弹框表格数据
        needTools: [],
        workTypes: [],
        coutentId: 1,
        filePaths: [],
        uploadData: {},
        form: {
          type: []
        },
        uploadform: {
          files: null
        },
        uploadoption: {
          labelWidth: 120,
          submitBtn: false,
          emptyBtn: false,
          column: [{
            label: "附件上传",
            loadText: "附件上传中，请稍等",
            prop: "files",
            type: "upload",
            limit: 1,
            span: 12,
            action: "/files/fileUpload"
          }]
        },
        dynamicValidateForm: {
          projectName: "",
          stakeholderIds: "",
          userIds: "",
          groupIds: "",
          workTypes: [],
          needTools: [],
          isOvertime: false,
          isOen: false,
          startTime: "",
          domains: [],
          address: [{
            address: "", //工程地址
            position: "", //地图坐标X,Y
            contacts: "", //联系人
            contactPhone: "", //联系电话
            title: "", //标题
            category: "", //地点类型
            type: "", //类型
            adcode: "", //地区编码
            province: "", //省
            city: "", //市
            district: "", //区县
            houseNum: "" //门牌号
          }]
        },
        //验证
        rules: {
          companyName:[{required: true, message: '请选择企业', trigger: 'blur' }],
          projectName: [{
            required: true,
            message: "需求名称不能为空",
            trigger: "blur"
          }],
          address: [{
            required: true,
            message: "工程地址不能为空",
            trigger: "change"
          }],
          startTime: [{
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }],
          duration: [{
            required: true,
            message: "请输入工作时长",
            trigger: "blur"
          }],
          needNum: [{
            required: true,
            message: "请选择工种",
            trigger: "blur"
          }],
          name: [{
            required: true,
            message: "请选择需求工具",
            trigger: "blur"
          }],
          tips: [{
            required: true,
            message: "请输入工种内容",
            trigger: "blur"
          }],
          isOen: [{
            required: true,
            message: "请输入发布渠道",
            trigger: "blur"
          }],
          houseNum1: [{
            required: true,
            message: "门牌号",
            trigger: "blur"
          }],
          contacts1: [{
            required: true,
            message: "联系人名称",
            trigger: "blur"
          }],
          contactPhone1: [{
            required: true,
            message: "联系人电话",
            trigger: "blur"
          }],
          allPrice:[
          {
            required: true,
            message: "请输入项目金额",
            trigger: "blur"
          },
          {
            pattern: /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[0-9][0-9]*\.\d{1,2})))$/,
            message: "仅能输入非负数字、小数点且小数点后为2位",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (999999 >= value.toString().split(".")[0]) {
                callback();
              } else {
                callback(new Error("输入的金额超出限定值"));
              }
            },
            trigger: "blur"
          }
        ]},

        tableoption: personnelget1,
        search: {
          companyId: this.companyId,
          pageNum: 1,
          pageSize: 10,
          userName: ""
        },
        page: {
          pageSizes: [10, 20, 50, 100],
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        tableoptionqz: groupqz,
        tableoptionworkers: tableoptionworkers,
        prospecting:[],    //勘查
        daohuoPlanList:[],  //到货
        installationPlanList:[], //安装
        arrivalPlanList:[],   //验收
        returnVisitPlanList:[], //回访
      };
    },
    filters: {
      getBaseApiUrl: function(uri) {
        if (uri) {
          return apiLink(uri);
        } else {
          return "";
        }
      },
      getBaseImgUrl: function(uri) {
        console.log(uri);
        if (uri) {
          return getImgLink(uri);
        } else {
          return "";
        }
      }
    },
    components: {
      editContent,
      editBasePlan,
      editDaohuoPlan,
      editInstallPlan,
      easyTable,
      myAvatar,
      companylist
    },
    created() {
      // this.getdicts();
      this.settime();
      this.initData();
      this.initDic();
      let editProject = JSON.parse(sessionStorage.getItem("editProject"));
      if(editProject){
        sessionStorage.removeItem("editProject")
        this.initProjectInfo(editProject.type,editProject.projectId);
      }else{
        this.initTypeTable(1);
      }

      this.uploadData = objKeySort({});
      this.tableoption.height = 400;
    },
    computed: {
      ...mapGetters(["permissions"])
    },
    mounted() {},
    methods: {
      refresh(companyId,name,state){
        this.companyId = companyId;
        this.companyName = name;
        this.totalStatus = false;

        // 企业是否认证
        this.companyState = state;
        if (this.companyState == 0) {
          this.VerificationVisible = true;
        }


      },
      //项目类型选择
      selectType: function(name) {
        let that = this;
        that.projectInfo.type = name
      },
      //初始化数据
      initData: function() {
        let that = this
        // let opendata = JSON.parse(window.sessionStorage.getItem("userInfo"));
        that.projectInfo.adds = [{
            address: '',
            houseNum: '',
            position: '',
            contacts: '',
            contactPhone: '',
            title: '',
            category: '',
            adcode: '',
            province: '',
            city: '',
            district: ''
          }],
          that.workScheduleRule.relevantContacts = [{
            type: '',
            name: '',
            phone: ''
          }],
          // //排班计划对象
          that.workScheduleRule.workTypeDict = [{
              id: '1',
              name: '搬运工',
              code: 'by',
              needNum: 0
            },
            {
              id: '2',
              name: '安装工',
              code: 'az',
              needNum: 0
            },
            {
              id: '3',
              name: '补漆工',
              code: 'bq',
              needNum: 0
            },
            {
              id: '4',
              name: '维修工',
              code: 'wx',
              needNum: 0
            }
          ],
          that.workScheduleRule.startDate = that.nowDate,
          //设置工作内容分页
          that.contentListData = {
            data: [],
            pageSize: 9,
            currentPage: 1
          }

      },
//平台代发企业查询
      companyGroup(){
        // 子组件按钮的是否允许操作
        this.$refs.childcompany.setuserid();
      },
      // 格式金额
      _formatAmount(e) {
        const val = e.target.value;
        const cVal = val * 1;
        if (cVal) {
          e.target.value = toFixed2(cVal);
          this.proForm.allPrice = toFixed2(cVal);
        }
      },
      //下一步
      nextSept() {
        let that = this;
        if (that.septId == 1) {
          that.infoNext();
        } else if (that.septId == 2) {
          that.workScheduleRuleNext();
        } else if (that.septId == 3) {
          that.publishingModeNext();
        } else if (that.septId == 4) {
          if(that.proForm.allPrice==0){
            console.log(that.proForm.allPrice)
            that.$notify({
              title: '温馨提示',
              message: '项目定价需要大于0',
              type: 'warning'
            });
            return;
          }else if(!that.proForm.allPrice){
            that.$notify({
              title: '温馨提示',
              message: '请输入项目定价',
              type: 'warning'
            });
            return;
          }
          // else if(that.allPrice.indexOf('.')>-1){
          //   that.$notify({
          //     title: '温馨提示',
          //     message: '项目定价只能为整数',
          //     type: 'warning'
          //   });
          //   return;
          // }
          else{
            that.septId = 5
          }
        }else if (that.septId == 5) {
          that.submitProjectInfo();
        }
      },
      // 项目信息下一步
      infoNext: function() {
        let that = this;
        if (!that.projectInfo.type) {
          this.$alert('请选择项目类型', '温馨提示', {
            confirmButtonText: '确定',
          });
          return;
        }
        let flag=false
        that.projectInfo.adds.forEach(item=>{
          if(!item.address){
            this.$alert('请输入工程地址', '温馨提示', {
              confirmButtonText: '确定',
            });
            flag = true
            return
          }
          if(!checkPhone(item.contactPhone)){
            this.$alert('请输入正确的手机号码', '温馨提示', {
              confirmButtonText: '确定',
            });
            flag = true
            return
          }
          if(item.contacts==''){
            this.$alert('请输入现场联系人', '温馨提示', {
              confirmButtonText: '确定',
            });
            flag = true
            return
          }

        })
        if(flag){
          return
        }

        if (!that.projectInfo.name) {
          this.$alert('请输入项目名称', '温馨提示', {
            confirmButtonText: '确定',
          });
          return;
        }

        if (!that.projectInfo.adds || that.projectInfo.adds.length <= 0) {
          this.$alert('请添加项目地址', '温馨提示', {
            confirmButtonText: '确定',
          });
          return;
        }
        if (!that.projectInfo.contents || that.projectInfo.contents.length <= 0) {
          this.$alert('请添加工作内容', '温馨提示', {
            confirmButtonText: '确定',
          });
          return;
        }
        // 上传选择的附件
        that.$refs.uploadWorkFj.submit();
        that.septId = 2;

      },
      //排版计划下一步
      workScheduleRuleNext: function() {
        let that = this;
        if (!that.workScheduleRule.duration) {
          this.$alert('请输入工作时长', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }
        if (!that.workScheduleRule.startDate) {
          this.$alert('请选择开始时间', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }

        var workerTypes = [];
        that.dic.workTypes.forEach(workType => {
          workerTypes.push({
            code: workType.code,
            name: workType.name,
            needNum: 0
          })
        })
        let dict=JSON.parse(JSON.stringify(that.workScheduleRule.workTypeDict))
        dict.forEach((workTypeTable,index) => {
          if(workTypeTable.code=='az'){workTypeTable.code='2'}
          if(workTypeTable.code=='by'){workTypeTable.code='1'}
          if(workTypeTable.code=='wx'){workTypeTable.code='4'}
          if(workTypeTable.code=='bq'){workTypeTable.code='3'}
          workerTypes[index].needNum=workTypeTable.needNum
        })
        that.priceType=workerTypes
        that.septId = 3
      },

      //发布方式下一步
      publishingModeNext: function() {
        let that = this;
        if (that.publishingMode.type == 0) {
          that.$alert('请选择发布类型', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }
        if (that.publishingMode.type == 1 && that.companyState != 2) {
          that.$alert('该企业还未认证，不能发布到需求大厅', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }
        if (that.publishingMode.type == 2 && that.publishingMode.groups.length <= 0) {
          that.$alert('您还没有选择群组', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }
        if (that.publishingMode.type == 3 && that.publishingMode.works.length <= 0) {
          that.$alert('您还没有选择师傅', '温馨提示', {
            confirmButtonText: '确定',
          })
          return;
        }
        let flag=false
        that.workScheduleRule.relevantContacts.forEach(item=>{
          if (item.type == '' && item.name == '' && item.phone == '') {
            flag=false
            return
          }
          if((item.name!=""||item.type!="")){
            if(!checkPhone(item.phone)){
              flag=true
              this.$alert('请输入正确的手机号', '温馨提示', {
                confirmButtonText: '确定',
              })
              return
            }
          }
          if(checkPhone(item.phone)){
            if((item.name=="")){
              flag=true
              this.$alert('请输入协作人姓名', '温馨提示', {
                confirmButtonText: '确定',
              })
              return
            }
            if((item.type=="")){
              flag=true
              this.$alert('请输入工作职责', '温馨提示', {
                confirmButtonText: '确定',
              })
              return
            }
          }
        })
        if(flag){
          return
        }
        // 平台预估：地址改为手输后不再取 adcode，固定按北京(1101)查询估价
        let mdata={
          cityCode:'1101'
        }
        getPredictPriceForCcode(objKeySort(mdata)).then(obj => {
          let _isShowPrice=false
          let _allPrice=0
          if(obj.status==200&&obj.data.data){
            _isShowPrice= obj.data.data.some(function(item){
              return item.predictPrice > 0
            })
            //设置 每个工种的金额
            obj.data.data.forEach(item=>{
              that.priceType.forEach(citem=>{
                if(item.workerType==citem.code){
                    item.needNum=citem.needNum
                    if(item.needNum>0){
                      if(item.predictPrice){
                        item.isShow=true //是否显示某工种估价
                      }else{
                        item.isShow=false
                        _isShowPrice=false
                      }
                      }else{
                      item.isShow=false
                    }
                    _allPrice += item.needNum*(item.predictPrice?item.predictPrice:0)
                  }
                })
                if(!item.needNum){
                  item.needNum=0
                }
            })
            that.septId = 4;
            that.cityPrice=obj.data.data;
            that.priceOfCity.isShowPrice=_isShowPrice;
            that.priceOfCity.thisCity='北京';
            that.priceOfCity.allPrice=_isShowPrice?_allPrice:'';
          }else{
            that.septId = 4
          }
        });
      },
      //确认信息下一步
      submitProjectInfo: function() {
        let that = this;
        that.submitData(1, function() {
          that.septId = 5
          that.timeOut = 4

          setTimeout(function() {
            that.toHome();
          }, 3000);
          that.updateTime();
        })
      },
      //返回首页
      toHome: function() {
        let that = this;
        that.initData();

      },
      updateTime: function() {
        let that = this;
        if (that.data.timeOut == 0) {
          return;
        }
        that.timeOut = that.timeOut - 1
        setTimeout(that.updateTime, 1000);
      },


      submitData: function() {
        let that = this;
        var filePaths = [];
        that.projectInfo.files.forEach(file => {
          filePaths.push({
            name: file.name,
            url: file.url
          })
        })
        that.projectInfo.files = filePaths;
        var stakeholderIds = [];
        that.publishingMode.stakeholders.forEach(stakeholder => {
          stakeholderIds.push(stakeholder.userId)
        })


        var groupIds = [];
        if (that.publishingMode.type == 2) {
          that.publishingMode.groups.forEach(group => {
            groupIds.push(group.id)
          })
        }

        var workerIds = [];
        if (that.publishingMode.type == 3) {
          that.publishingMode.works.forEach(worker => {
            workerIds.push(worker.id)
          })
        }

        var workTypes = [];
        that.workScheduleRule.workerTypes.forEach(workerType => {
          if (workerType.needNum > 0) {
            workTypes.push({
              workTypeCode: workerType.code,
              workTypeName: workerType.name,
              needNum: workerType.needNum
            })
          }

        })
      },
      // 修改工作时长 并根据时长修改
      durationInput(value) {
        let that = this
        that.workScheduleRule.duration = value
        that.initTypeTable(1);
      },

      //选择开工时间
      changeTableDate(e) {
        let that = this
        console.log("开工时间：",e);
        that.workScheduleRule.startDate = e
        that.initTypeTable(1);
      },

      //初始化排班计划表
      //type  1初始化 第一次进入 2修改操作  3再次发布操作
      initTypeTable: function(type) {
        let that = this;
        if (that.workScheduleRule.duration <= 0) {
          return
        }
        var workTypeTable = that.workScheduleRule.workTypeTable;
        if (!workTypeTable) {
          workTypeTable = [];
        } else {
          workTypeTable.splice(that.workScheduleRule.duration, workTypeTable.length);
        }
        for (var i = 0; i < that.workScheduleRule.duration; i++) {
          if (!workTypeTable[i]) {
            workTypeTable[i] = {}
          }
          if(type==1){
            workTypeTable[i]['workTime'] = getDateStr(that.workScheduleRule.startDate, i);
          }
          //重新发布
          if(type==3){
            workTypeTable[i]['workTime'] = dateSplit(that.workScheduleRule.workTypeTable[i].workScheduleRuleDate.date, 3);
          }
          that.workScheduleRule.workTypeDict.forEach((dict,index) => {
            if(workTypeTable[i][dict.code]){
              workTypeTable[i][dict.code] = workTypeTable[i][dict.code]=='-'?0: workTypeTable[i][dict.code]
            }
            if (workTypeTable[i].workTypeNum&&workTypeTable[i].workTypeNum[index].value) { //第一次进入数据判定
              if(type!=2){
                workTypeTable[i][dict.code] = workTypeTable[i].workTypeNum[index].value
              }
            } else if(!(parseInt(workTypeTable[i][dict.code])>0)) { //无属性 直接赋值为-
              workTypeTable[i][dict.code] = 0
            }

          })
          if(type!=3){
            that.getWorkTypeNum(workTypeTable)
          }
        }
        that.workScheduleRule.workTypeTable = workTypeTable;
      },

      //接受子组件的传值
       getSonTable(data) {
        let that = this
         console.log("选择日期：",data);
        if(data.isdate){
          if(data.value&&data.value!=null){
            that.workScheduleRule.workTypeTable[data.index].workTime=data.value;
            //更改日期组件的时间
            that.workScheduleRule.startDate = data.value+' 09:00:00';
          }else{
            that.workScheduleRule.workTypeTable[data.index].workTime="";
            //更改日期组件的时间
            that.workScheduleRule.startDate = "";
          }

           console.log(that.workScheduleRule.startDate)
        }else{
          that.workScheduleRule.workTypeTable = data
          that.initTypeTable(2)
        }
      },

      //获取工种数量
      getWorkTypeNum(arr) {
        let that = this
        let needWorkNum = that.workScheduleRule.workTypeDict
        let [azNum, byNum, wxNum, bqNum] = [0, 0, 0, 0]
        arr.forEach((item) => {
          byNum += parseInt(item.by=='-'?0:item.by)
          azNum += parseInt(item.az=='-'?0:item.az)
          bqNum += parseInt(item.bq=='-'?0:item.bq)
          wxNum += parseInt(item.wx=='-'?0:item.wx)
        })
        needWorkNum[0].needNum = byNum
        needWorkNum[1].needNum = azNum
        needWorkNum[2].needNum = bqNum
        needWorkNum[3].needNum = wxNum
        that.workScheduleRule.workTypeDict = needWorkNum
      },

      //添加协作联系人
      addAltconnecter() {
        this.workScheduleRule.relevantContacts.push({
          type: '',
          name: '',
          phone: ''
        });
      },

      //选择发布方式
      selectPublishingMode(e) {
       let that = this;
        if (e.currentTarget.dataset.type == 1) {
          //判断是否能进行大厅发布
          if (that.companyState != 2) {
            this.$alert('该企业还未认证，不能发布到需求大厅', '温馨提示', {
              confirmButtonText: '确定',
            })
            return
          }
          that.publishingMode.type = 1;
        } else if (e.currentTarget.dataset.type == 2) {
          that.workerGroupVisible = true
          that.workerGroup()
          that.publishingMode.type = 2;
        } else if (e.currentTarget.dataset.type == 3) {
          that.workerVisible = true
          that.workerArr()
          that.publishingMode.type = 3;
        }

      },
      editInfo(e) {
        let that = this
        that.septId = e.currentTarget.dataset.type
        that.isReEdit = true
      },

      toManage() { //去项目管理页面查看状态

      },
      handleImgRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleVideoRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },

      // 设置工作内容 获取子组件的工作内容
      setContent(content) {
        let that = this
        if (content) {
          if (content.id) {
            for (let i = 0; i < that.projectInfo.contents.length; i++) {
              const content = that.projectInfo.contents[i];
              if (content.id === content.id) {
                that.projectInfo.contents[i] = content;
              }
            }
          } else {
            content.id = that.coutentId++;
            that.projectInfo.contents.push(content);
          }
        }
      },
      addContent() {
        let that = this
        if (that.contentSource==1&&that.projectInfo.contents&&that.projectInfo.contents!=null&&that.projectInfo.contents.length>0) {
          this.$confirm('添加后覆盖所有已导入的工作内容，是否继续？', '温馨提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.projectInfo.contents = []
            that.addWorkContentDialog = true
            that.contentSource=2
          that.$refs.editContent.setData();
          }).catch(() => {
            return
          });
        }else{
          that.addWorkContentDialog = true
          that.$refs.editContent.setData();
          that.contentSource=2
        }
      },
      editContent(content) {
        this.$refs.editContent.setData(content);
      },

      //-------------现场勘查计划---------------
      addProspection() {
        let that = this
        that.planTypeName="勘查";
        that.$refs.editBasePlan.setData(1);
      },
      editProspection(content,index) {
        debugger
        content.index = index;
        this.$refs.editBasePlan.setData(1,content);
      },


      //-------------到货计划---------------
      addDaohuolPlan() {
        let that = this
        that.planTypeName="到货";
        that.$refs.editDaohuoPlan.setData();
      },
      editDaohuoPlan(content,index) {
        debugger
        content.index = index;
        this.$refs.editDaohuoPlan.setData(content);
      },

      //-------------安装计划---------------
      addInstallPlan() {
        let that = this
        that.planTypeName="安装";
        that.$refs.editInstallPlan.setData();
      },
      editInstallPlan(content,index) {
        content.index = index;
        this.$refs.editInstallPlan.setData(content);
      },


      //-------------验收计划---------------
      addArrivalPlan() {
        let that = this
        that.planTypeName="验收";
        that.$refs.editBasePlan.setData(4);
      },
      editArrivalPlan(content,index) {
        content.index = index;
        this.$refs.editBasePlan.setData(4,content);
      },

      //-------------回访计划---------------
      addReturnVisitPlan() {
        let that = this
        that.planTypeName="回访";
        that.$refs.editBasePlan.setData(5);
      },
      editReturnVisitPlan(content,index) {
        content.index = index;
        this.$refs.editBasePlan.setData(5,content);
      },




// 设置基础内容 获取子组件的工作内容
      setBasePlanContent(type,content) {
        let that = this
        debugger
        let index = content.index;
        switch (type){
          case 1:
            console.log(that.prospecting);
            if (index>=0) {
              this.prospecting[index] = content;
            } else {
              this.prospecting.push(content);
            }
            break;
          case 2:
            if (index>=0) {
              that.daohuoPlanList[index] = content;
            } else {
              that.daohuoPlanList.push(content);
            }
            break;
          case 3:
            if (index>=0) {
              that.installationPlanList[index] = content;
            } else {
              that.installationPlanList.push(content);
            }
            break;
          case 4:
            if (index>=0) {
              that.arrivalPlanList[index] = content;
            } else {
              that.arrivalPlanList.push(content);
            }
            break;
          case 5:
            if (index>=0) {
              that.returnVisitPlanList[index] = content;
            } else {
              that.returnVisitPlanList.push(content);
            }
            break;
          default:
            this.$alert('计划类型参数错误', '温馨提示', {
              confirmButtonText: '确定',
            })
            return;
        }


      },

      //删除计划
      deletePlan(type,index) {
        let that = this
        switch (type){
          case 1:that.prospecting.splice(index, 1);break;
          case 2:that.daohuoPlanList.splice(index, 1);break;
          case 3:that.installationPlanList.splice(index, 1);break;
          case 4:that.arrivalPlanList.splice(index, 1);break;
          case 5:that.returnVisitPlanList.splice(index, 1);break;
          default:
            this.$alert('删除计划类型参数错误', '温馨提示', {
              confirmButtonText: '确定',
            })
            return
        }

      },

      initDic() {
        let that=this
        getDictList(objKeySort({
          code: "worktype"
        })).then(response => {
          that.dic.workTypes = response.data.data.worktype;
          that.tableoptionworkers.column[3].dicData = response.data.data.worktype;
        });
        getDictList(objKeySort({
          code: "worker_skill"
        })).then(response => {
          that.dic.skillTips = response.data.data.worker_skill;
        });
        fetchList(objKeySort()).then(response => {
          that.dic.groups = response.data.data;
          that.tableoptionworkers.column[5].dicData = response.data.data;
        });
      },
      //需求大厅
      xqdt() {
        if (this.companyState != 2) {
          this.VerificationVisible = true;
          return;
        }
        if (this.dynamicValidateForm.isOen == false) {
          this.classA = true;
          this.dynamicValidateForm.isOen = true;
        } else {
          this.classA = false;
          this.dynamicValidateForm.isOen = false;
        }
      },
      //获取项目id信息请求数据
      initProjectInfo(editType,projectId) {
          let that =this
          getProjectInfo(objKeySort({
            projectId: projectId
          })).then(response => {
            that.projectInfo.name = response.data.data.projectName//项目名称
            that.projectInfo.adds =
              response.data.data.projectAddresses//项目地址
            that.projectInfo.type= response.data.data.projectType//项目类型
            that.projectInfo.describe= response.data.data.describe//备注
            that.projectInfo.files= that.getFilePaths(response.data.data.filePaths) //附件路径 ;
            that.workScheduleRule.duration = response.data.data.duration
            that.workScheduleRule.isWorkOvertime = response.data.data.isOvertime==1?true:false //是否需要加班
            that.workScheduleRule.startDate=dateSplit(response.data.data.startTime,2)
            // that.workScheduleRule.workTypeTable=response.data.data.workTypeTable?JSON.parse(response.data.data.workTypeTable):[] //排班计划表格数据
            // 把workTypes 中数据转到workTypeDict中用于页面显示
            // let _workTypes=JSON.parse(response.data.data.workTypes?response.data.data.workTypes:[])
            // _workTypes.forEach(item=>{
            //   that.workScheduleRule.workTypeDict.forEach(citem=>{
            //     if(item.workTypeCode==citem.id){
            //       citem.needNum=item.needNum
            //     }
            //   })
            // })
            //
            // that.initTypeTable(3);
            let type=0;
            if(response.data.data.isOpen==1){
              type = 1;
            }else if(response.data.otherData.inviteGroups){
              type = 2;
            }else if(response.data.otherData.inviteWorkers){
              type = 3;
            }
            that.publishingMode.type=type;
            that.publishingMode.groups=response.data.otherData.inviteGroups?response.data.otherData.inviteGroups:[]; //发布到群组，群组数据,
            that.publishingMode.works=that.getWorks(response.data.otherData.inviteWorkers?response.data.otherData.inviteWorkers:[]); //发布到师傅,师傅数据,
            let _stakeholders=response.data.otherData.stakeholders?response.data.otherData.stakeholders : [];
            _stakeholders.forEach(item=>{
              if(item.avatar){
                item.avatar=that.getimgpath(item.avatar)
              }
            })
            that.publishingMode.stakeholders =_stakeholders
            that.projectId=(editType=='release'||editType=='update')?projectId:'',   //update修改，release重新发布  republish再次发布
            that.contentSource=response.data.data.contentSource?response.data.data.contentSource:2
            if(that.contentSource==2){
              that.projectInfo.contents =that.getContents(response.data.data.workProjectContents) //工作内容;
            }else{
              if(response.data.data.workProjectContents.length>0){
                response.data.data.workProjectContents.forEach((item,index)=>{
                  item.id=index+1
                })
                that.projectInfo.contents =response.data.data.workProjectContents //工作内容;
              }
            }
            that.workScheduleRule.relevantContacts=response.data.data.relevantContacts?JSON.parse(response.data.data.relevantContacts):[];
            //设置 金额
            that.proForm.allPrice=response.data.data.price;
            that.prospecting=response.data.data.projectPlanProspectings;

            let daohuoPlanList = response.data.data.projectPlanDaohuos;
            daohuoPlanList.forEach(item=>{
              item.carIformationList = JSON.parse(item.carIformationList);
              item.arrivalDataInfo = JSON.parse(item.arrivalDataInfo);
            })
            that.daohuoPlanList=daohuoPlanList;
            that.installationPlanList=response.data.data.projectPlanInstallations;
            that.arrivalPlanList=response.data.data.projectPlanArrivals;
            that.returnVisitPlanList=response.data.data.projectPlanReturnvisits;
          });

      },

      //重新整理附件数据
      getFilePaths:function(data){
        let filePaths = JSON.parse(data);
        let newFilePaths = [];
        filePaths.forEach(filePath=>{
          newFilePaths.push({
            name:filePath.name,
            url:filePath.url,
            type:matchType(filePath.name)
          })
        })
        return newFilePaths;
      },


      //重新整理工作内容数据
      getContents:function(data){
        var contents = [];
        data.forEach(content=>{
          var firstImg = '';
          var imgNum = 0;
          var vidNum = 0;
          let imgPaths = content.imgPaths?content.imgPaths.split(','):[];
          let videoPaths = content.videoPaths?content.videoPaths.split(','):[];
          if(imgPaths&&imgPaths.length>0){
            imgNum = imgPaths.length;
            firstImg = imgPaths[0];
          }
          if(videoPaths&&videoPaths.length>0){
            vidNum = videoPaths.length
          }
          contents.push({
            tips:content.tips,
            firstImg:firstImg?firstImg:'',
            imgPaths:content.imgPaths,
            videoPaths:content.videoPaths,
            imgCount:imgNum,
            videoCount:vidNum,
            contentId:content.contentId
          })
        })
        return contents;
      },

      getWorks:function(data){
        let that=this
        let works = [];
        data.forEach(item =>{
          if(item.avatar){
            if(item.avatar.indexOf('http')==-1){
              item.avatar=that.getimgpath(item.avatar)
            }
          }
          works.push({
            avatar: item.avatar,
            headimgurl: item.headimgurl,
            name: item.userName,
            id: item.userId
          })
        })
        return works;
      },

      //默认时间
      settime() {
        var myDate = new Date(); //获取系统当前时间
        var month =
          myDate.getMonth() + 1 > 9 ?
          myDate.getMonth() + 1 :
          "0" + (myDate.getMonth() + 1);
        var day =
          myDate.getDate()+1 >= 10 ?
          myDate.getDate()+1 :
          "0" + (myDate.getDate()+1);
          this.nowDate = myDate.getFullYear() + "-" + month + "-" + day + " 09:00:00"
      },

      //删除多余地址
      deleteaddress(index) {
        this.projectInfo.adds.splice(index, 1)
        // this.dynamicValidateForm.address.splice(index, 1);
      },
      //删除多余协作人
      deleteAltConnecter(index) {
        let that = this
        that.workScheduleRule.relevantContacts.splice(index, 1);
      },
      //删除多余任务内容
      deletetask(index) {
        let that = this
        that.projectInfo.contents.splice(index, 1);

      },

      //获取通用标签
      getdicts() {
        this.dynamicValidateForm.workTypes.length = 0;
        this.needTools.length = 0;
        getdicts(objKeySort()).then(response => {
          let datadic = response.data.data;
          //处理需求师傅
          for (let i = 0; i < datadic.worktype.length; i++) {
            this.dynamicValidateForm.workTypes.push({
              needNum: "",
              workTypeName: datadic.worktype[i].name,
              workTypeCode: datadic.worktype[i].id
            });
          }

          //处理需求工具
          for (let i = 0; i < datadic.needTools.length; i++) {
            this.needTools.push({
              name: datadic.needTools[i].name,
              code: datadic.needTools[i].id
            });
          }
        });
      },

      // 过滤出id
      dataFilter(dataItem) {
        var dataArr = [];
        for (var i of dataItem) {
          i.id?dataArr.push(i.id):dataArr.push(i.userId)
        }
        return dataArr.join(",");
      },

      //发布项目
      ReleaseInfo() {
        let that = this
        let data = that.Preservation(1)
        that.quertok(data)
      },

      //取消操作
      Releasecancel() {
        this.$confirm('是否需要保存至项目列表?', '温馨提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.savebtn()
        }).catch(action => {
          if(action === 'cancel'){
            sessionStorage.removeItem("editProject");
            this.$router.push("/project/list");
            this.$message({
              type: 'info',
              message: '已取消'
            });
          }
        });
      },

      //保存信息
      savebtn() {
        let that = this
        if(that.septId>1){
          that.quertok(that.Preservation(0))
          that.$message({
            type: 'info',
            message: '项目信息已保存'
          });
        }else{
          that.$notify({
           title: '温馨提示',
           message: '您填写的信息过少，不能保存（至少进入下一步才可以保存）',
           duration: 3000,
           type:'warning'
         });
        }
      },

      //确定
      quertok(data) {
        insertOrUpdate(objKeySort(dealElement(data))).then(response => {
          console.log(response)
          sessionStorage.removeItem("editProject");
          this.$router.push("/platformProject/list");
        });
      },

      //认证企业
      renzheng() {
        this.$router.push("/admin/legalize");
      },

      //数据处理
      Preservation(projectstate) {
        let that = this
        //协作人判断 因为需要数据渲染dom 默认添加一条空数据

        let _relevantContacts = that.workScheduleRule.relevantContacts
        if(_relevantContacts&&_relevantContacts.length>0){
          _relevantContacts.forEach(item => {
            if (item.type == '' && item.name == '' && item.phone == '') {
              that.workScheduleRule.relevantContacts = []
            }
          })
        }



       this.publishingMode.worksIds = this.dataFilter(this.publishingMode.works); //过滤为id
       this.publishingMode.groupIds = this.dataFilter(this.publishingMode.groups); //过滤为id
       this.publishingMode.stakeholderIds = this.dataFilter(this.publishingMode.stakeholders); //过滤为id
       let filePaths = [];
       that.projectInfo.files.forEach(item=>{
         let filePath = {
           name:item.name,
           url:item.url
         }
         filePaths.push(filePath);
       })


       let data={
         companyId : that.companyId,
           projectId:that.projectId,
           projectType: that.projectInfo.type,
           projectName: that.projectInfo.name,
           addresses: JSON.stringify(that.projectInfo.adds),
           workProjectContent: JSON.stringify(that.projectInfo.contents),
           describe: that.projectInfo.describe?that.projectInfo.describe:'',
           filePaths: JSON.stringify(filePaths),

           duration: that.workScheduleRule.duration,
           startTime: that.workScheduleRule.startDate,


           relevantContacts: JSON.stringify(that.workScheduleRule.relevantContacts),
           isOvertime: that.workScheduleRule.isWorkOvertime ? 1 : 0,

           stakeholderIds: that.publishingMode.stakeholderIds,
           isOpen: that.publishingMode.type == 1 ? 1 : 0,
           groupIds: that.publishingMode.groupIds,
           workerIds: that.publishingMode.worksIds,
           type: projectstate,
           contentSource:that.contentSource==2?2:1,//工作内容类型 导入来源为1 手动添加为2
            price:that.proForm.allPrice,
           platformPredictPrice:that.priceOfCity.allPrice,
         prospecting:JSON.stringify(that.prospecting),    //勘察
         daohuoPlanList:JSON.stringify(that.daohuoPlanList),  //到货
         installationPlanList:JSON.stringify(that.installationPlanList), //安装
         arrivalPlanList:JSON.stringify(that.arrivalPlanList),   //验收
         returnVisitPlanList:JSON.stringify(that.returnVisitPlanList), //回访
       }
        return data;
      },
      isArrayFn:function (obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
      },
      cancelUpload(){
        let that = this;
        that.uploadfileDialog = false //关闭dialog
      },
      submitUpload() {
        let that = this
        that.$refs.uploadContent.submit();
        that.uploadfileDialog = false //关闭dialog
      },
      //分页操作
      handleCurrentChange(currentPage) {
        this.contentListData.currentPage = currentPage
      },

      // 我的师傅多选
      workSelectionChange(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownWorker = val;
        }else{
          // 有勾选的数据
          if(that.ownWorker.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownWorker.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownWorker.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.workerCrud.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.workerData.length>0){
            that.workerData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.workerCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownWorker.push(item)
                that.$nextTick(() => {
                  that.$refs.workerCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
      },
      // 我的师傅确定选择
      workerTrue() {
        let that=this
        that.workerVisible = false;
        that.publishingMode.worksIds = that.dataFilter(that.ownWorker); //过滤为id
        that.publishingMode.works = that.ownWorker;
        that.publicproject()
      },

      //展示师傅列表
      workerArr() {
        let that = this
          that.ownWorker=[];
        that.searchgr.companyId = that.companyId;
          getWorkerList(objKeySort(that.searchgr)).then(response => {
          that.workerData = response.data.data;
          that.workerData.forEach(data => {
            // data.workTypeIds = that.formatterWorkType(data.workTypeIds);
            if(that.publishingMode.works&&that.publishingMode.works.length>0){
              that.publishingMode.works.forEach(item=>{
                if(item.id==data.id){
                  data.check=true
                  that.ownWorker.push(data)
                  that.$nextTick(() => {
                    that.$refs.workerCrud.toggleRowSelection(data, true);
                  })
                }
              })
            }
          })
        });
        that.workerVisible = true;
      },

      //项目相关人 弹窗
      showXgr(){
        let that =this
        if(!that.companyId){
          that.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
          that.companyId = that.userInfo.companyId;
        }
        that.projectManVisible = true;
        that.getxmxgr()
      },
      selectionChange(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownStakeholders = val;
        }else{
          // 有勾选的数据
          if(that.ownStakeholders.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownStakeholders.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownStakeholders.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.userCrud.toggleRowSelection(val, false);
                });
              }
            })
          }
          if(that.comworkerData.length>0){
            that.comworkerData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.userCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownStakeholders.push(item)
                that.$nextTick(() => {
                  that.$refs.userCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
      },
      // 项目相关人确定选择
      chooseTrue() {
        let that = this
        that.projectManVisible = false;
        that.publishingMode.stakeholders=that.ownStakeholders
        that.publishingMode.stakeholderIds = that.dataFilter(that.ownStakeholders); //过滤为id
      },

      // 项目相关人关闭标签
      handleClose(tag) {
        this.publishingMode.stakeholders.splice(this.publishingMode.stakeholders.indexOf(tag), 1);
      },
      //项目相关人关查询
      getxmxgr() {
        let that = this
        that.ownStakeholders=[]
        that.comworkerData = [];
        that.search.companyId = that.companyId;
        that.search.pageNum = 1;
        that.search.pageSize = 999;
        getWorkerInfo(objKeySort(that.search)).then(response => {
          that.page.total = response.data.data.total;
          response.data.data.rows.forEach(comworker => {
            if (that.userInfo.id != comworker.id) {
              that.comworkerData.push(comworker);
            }
            if(comworker.avatar&&comworker.avatar.indexOf('http')==-1){
              comworker.avatar=that.getimgpath(comworker.avatar)
            }
            if(that.publishingMode.stakeholderIds){
              let _ids=that.publishingMode.stakeholderIds.split(',')
              _ids.forEach(item=>{
                if(item==comworker.id){
                  comworker.check=true
                  that.ownStakeholders.push(comworker)
                  that.$nextTick(() => {
                    that.$refs.userCrud.toggleRowSelection(comworker, true);
                  })
                }
              })
            }

          });
          });
      },
      workerGroupchange(val) {
        let that=this
        if(Object.prototype.toString.call(val)== '[object Array]'){
          that.ownGroup = val;
        }else{
          // 有勾选的数据
          if(that.ownGroup.length>0){
            // 遍历并判断是否是选择了 已在选择数据中的数据
            that.ownGroup.slice().reverse().forEach((citem, index, object)=>{
              if(citem.id==val.id){
                // 取消已经勾选的
                that.ownGroup.splice(object.length - 1 - index, 1);
                // citem.check=false
                that.$nextTick(() => {
                    that.$refs.groupCrud.toggleRowSelection(val, false);
                });
              }
            })
          }

          if(that.workerGroupData.length>0){
            that.workerGroupData.forEach(item=>{
              if(item.id==val.id&&item.check==true){
                 item.check=false
                 that.$nextTick(() => {
                   that.$refs.groupCrud.toggleRowSelection(item, false);
                 })
              }else if((val.check==undefined||val.check==false)&&item.id==val.id){
                item.check=true
                that.ownGroup.push(item)
                that.$nextTick(() => {
                  that.$refs.groupCrud.toggleRowSelection(item, true);
                })
              }
            })
          }
        }
        // this.workerGrouptagsArr = val;
      },
      // 师傅群组确定选择
      workerGroupTrue() {
        let that=this
        that.workerGroupVisible = false;
        that.publishingMode.groupIds = that.dataFilter(that.ownGroup); //过滤为id
        that.publishingMode.groups = that.ownGroup;
        that.publicproject()
      },
      // 师傅群组关闭标签
      workerGroupClose(tag) {
        this.workerGrouptags.splice(this.workerGrouptags.indexOf(tag), 1);
      },
      workerGroupworker(data) {
        this.ownWorker = data;
      },
      // 师傅关闭标签
      workerClose(tag) {
        this.ownWorker.splice(this.ownWorker.indexOf(tag), 1);
      },
      getSerialNumber(index) {
        return index + 1;
      },

      // 师傅群组弹框
      workerGroup() {
        let that = this
        that.ownGroup=[]
        getGroupList(objKeySort({
          companyId: that.companyId
        })).then(response => {
          that.workerGroupData = response.data.data;
          that.publishingMode.groups.forEach(item=>{
            that.workerGroupData.forEach(data=>{
              if(data.id==item.id){
                data.check=true
                that.ownGroup.push(data)
                that.$nextTick(() => {
                  that.$refs.groupCrud.toggleRowSelection(data, true);
                })
              }
            })
          })
        });
        that.workerGroupVisible = true;
      },

      //刷新列表操作
      formatterWorkType(workTypeIds) {
        var workTypeNames = "";
        if (workTypeIds && workTypeIds.length > 0) {
          workTypeIds.split(",").forEach(workerTypeId => {
            if (this.dic.workTypes) {
              this.dic.workTypes.forEach(workerType => {
                if (workerType.id == workerTypeId) {
                  workTypeNames = workTypeNames + workerType.name + ",";
                }
              });
            } else {
              return workTypeIds;
            }
          });
        }
        if (workTypeNames.length > 0) {
          workTypeNames = workTypeNames.substring(0, workTypeNames.length - 1);
        }
        return workTypeNames;
      },

      // 提交数据
      publicproject() {
        var that = this
        if (!(that.publishingMode.type>0)) {
          that.$message({
            type:'info',
            message:'至少选择一项发布方式'
          })
          return
        }
        if(that.publishingMode.type==2&&that.publishingMode.groupIds==""){
          that.$message({
            type:'info',
            message:'至少选择一个群组'
          })
          return
        }
        if(that.publishingMode.type==3&&that.publishingMode.worksIds==""){
          that.$message({
            type:'info',
            message:'至少选择一个师傅'
          })
          return
        }

        let submitData = {
          projectId: that.projectId,
          isOen: that.publishingMode.type==1?1:0,
          groupIds: that.publishingMode.groupIds?that.publishingMode.groupIds.join(','):'',
          userIds: that.publishingMode.worksIds?that.publishingMode.worksIds.join(','):''
        }
        updateProjectChannel(objKeySort(submitData)).then(obj=>{
          if(obj.data.code==200){
            that.$message({
              type:'success',
              message:'修改成功'
            })
           that.publishingMode.group = that.ownGroup;
           that.publishingMode.works = that.ownWorker;
           that.xqPageVisable.fBDlg=false
          }else{
            that.$message({
              type:'warning',
              message:obj.data.msg
            })
          }
        })
      },

      // 导入
      importBtn() {
        let that = this
        if (that.contentSource==2&&that.projectInfo.contents&&that.projectInfo.contents!=null&&that.projectInfo.contents.length>0) {
          this.$confirm('导入后覆盖所有已添加的工作内容，是否继续？', '温馨提示', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.projectInfo.contents = []
            //获取token
            that.uploaddata.Token = sessionStorage.getItem("access_token");
            // that.uploaddata.projectId = that.projectId;
            console.log(that.uploaddata);
            that.uploadfileDialog = true;
            that.contentSource = 1;
          }).catch(() => {
            return
          });
        }else{
          //获取token
        that.uploaddata.Token = sessionStorage.getItem("access_token");
        // that.uploaddata.projectId = that.projectId;
        console.log(that.uploaddata);
        that.uploadfileDialog = true;
        that.contentSource = 1;
        }
      },

      //上传成功
      handleAvatarSuccess(response) {
        this.handleSuccessstate = true;
        this.uploadfileDialog = false;
        //添加id值 imgCount videoCount
        if(response.data&&response.data.length>0){
          response.data.forEach((item,index)=>{
            item.id=index+1
            item.imgPaths?(item.imgCount=1):(item.imgCount=0)
            item.videoPaths?(item.videoCount=1):(item.videoCount=0)
          })
        }
        this.projectInfo.contents = response.data?response.data:[];
        this.$refs.uploadContent.clearFiles();
      },

      handleWorkFjSuccess(response) {
        let that = this
        // 变换属性名
        let fItem = {}
        fItem.name = response.data.fileName,
        // fItem.companyId = response.data.companyId,
        // fItem.createTime = response.data.createTime,
        fItem.url = response.data.filePath,
        // fItem.fileTips = response.data.fileTips,
        // fItem.id = response.data.id,
        // fItem.userId = response.data.userId
        fItem.type = matchType(response.data.fileName)
        that.projectInfo.files.push(fItem)
      },

      handleFjRemove(file) {
        let that=this
        that.projectInfo.files.slice().reverse().forEach((item, index, object)=>{
          if(file.id&&item.id){
            if(item.id==file.id){
              that.projectInfo.files.splice(object.length - 1 - index, 1);
            }
          }else{
            if(item.uid==file.uid){
              that.projectInfo.files.splice(object.length - 1 - index, 1);
            }
          }
        })
      },

      beforeFjRemove(file){
        let that=this
        return that.$confirm(`确定移除${ file.name }？`, '温馨提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning',
         })
      },

      //取消上传
      close() {
        this.uploadfileDialog = false;
        this.uploadform.files = undefined;
      },

      //上传后的方法
      uploadAfter(res, done) {
        done();
        this.uploadform.files.push({
          label: "反馈图片",
          value: res.data.data.filePath
        });
        for (var i = 0; i < this.uploadform.files.length; i++) {
          if (this.uploadform.files[i].value === undefined)
            this.uploadform.files.splice(i, 1);
        }
        this.uploadform.files.push(res.data.data.filePath);
      },

      // 详细工作内容
      contentList() {
        this.createVisible = true;
      },

      // 新增项目相关负责人
      addProjectPeople() {
        this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        this.companyId = this.userInfo.companyId;
        this.getxmxgr();
        this.projectManVisible = true;
      },

      addDomain() {
        this.dynamicValidateForm.domains.push({
          tips: "",
          key: Date.now()
        });
      },
      address() {
        var opendata = JSON.parse(window.sessionStorage.getItem("userInfo"));
        this.projectInfo.adds.push({
          address: '',
          houseNum: '',
          position: '',
          contacts: opendata.name,
          contactPhone: opendata.phone,
          title: '',
          category: '',
          adcode: '',
          province: '',
          city: '',
          district: ''
        })
      },

      //清空
      searchReset() {
        this.page.currentPage = 1;
        this.page.pageSize = 20;
        this.getxmxgr();
      },

      //搜索数据
      searchChange(params) {
        if (!params.name) {
          params.name = "";
        }
        this.search.keyword = params.condition;
        this.getxmxgr();
      },

      //搜索群组信息
      searchChangeqz(params) {
        let searchqz = {
          condition: params.condition ? params.condition : "",
          groupId: params.groupNames,
          isForeman: params.isForeman,
          workTypeId: params.workTypeIds
        };
        getGroupList(objKeySort(dealElement(searchqz))).then(response => {
          this.workerData = response.data.data;
          this.workerData.forEach(data => {
            data.workTypeIds = this.formatterWorkType(data.workTypeIds);
          });
        });
      },

      //搜索师傅信息
      searchChangegr(params) {
        this.searchgr = {
          condition: params.condition ? params.condition : "",
          groupId: params.groupNames,
          isForeman: params.isForeman,
          workTypeId: params.workTypeIds
        };
        this.searchgr.companyId = this.companyId;
        getWorkerList(objKeySort(dealElement(this.searchgr))).then(response => {
          this.workerData = response.data.data;
          this.workerData.forEach(data => {
            data.workTypeIds = this.formatterWorkType(data.workTypeIds);
          });
        });
        console.log(this.searchgr);
      },

      //图片路径处理
      getimgpath(data) {
        if(data.indexOf('http')==-1){
          return getImgLink(data);
        }else{
          return data
        }
      },

      //编辑预估价格
      editPrice(e){
        let that=this
        that.proForm.allPrice=e?e:0
      },
      //使用预估价格
      useThisPrice(){
        let that=this;
        if(that.priceOfCity.allPrice){
          that.proForm.allPrice=that.priceOfCity.allPrice;
        }
      },
    }

  };
</script>
<style scoped="scoped">
  .el-date-editor.el-input {
    width: 65% !important;
  }

  .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
    content: '' !important;
    margin-right: 0px !important;
  }

  .el-button+.el-button {
    margin-left: 40px;
  }

  .el-dialog__header {
    border-bottom: none !important;
  }

  .el-upload--picture-card {
    width: 125px !important;
    height: 125px !important;
  }

  .el-upload-list__item {
    height: 40px !important;
    background: rgba(245, 247, 250, 1) !important;
    border-radius: 3px !important;
  }

  .limit_width ::v-deep .el-upload-list__item .el-icon-close-tip{
    top: 15px;
    right: 35px;
  }
  .foot_btn  ::v-deep .el-button:focus{
    color: #FFF;
    background: #3d7eff
  }
  .foot_btn  ::v-deep .el-button:hover{
    color: #FFF;
    background-color: #3672ea;
  }
  ::v-deep input::-webkit-outer-spin-button, ::v-deep input::-webkit-inner-spin-button{
     -webkit-appearance: none !important;
     appearance: none !important;
     margin: 0;
  }

  ::v-deep input[type="number"]{
   -moz-appearance:textfield;
   }
</style>
